import { useRef, useState } from "react";
import styled from "styled-components";
import { Box } from "@vinomofo/components";
import { PlayPauseButton } from "./PlayPauseButton";

const VideoBackgroundContainer = styled(Box)`
  color: #fff;
  overflow: hidden;
  margin-top: 0;
  padding-top: 0;
  display: block;
  position: absolute;
`;

const MediaElement = styled(Box)`
  video,
  img {
    vertical-align: baseline;
    display: inline-block;
    object-fit: cover;
    z-index: -100;
    background-position: 50%;
    background-size: cover;
    width: 100%;
    height: 100%;
    margin: auto;
    position: absolute;
    inset: -100%;
  }
`;

type VideoBackgroundProps = {
  videoSrc?: string;
  heroImageBackground?: string;
};

const VideoBackground = ({
  videoSrc,
  heroImageBackground,
}: VideoBackgroundProps) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isPlaying, setIsPlaying] = useState(true);

  const togglePlay = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
      return;
    }
    setIsPlaying(!isPlaying);
  };

  return (
    <>
      <VideoBackgroundContainer
        width="100%"
        zIndex="1"
        height={["40vh", "50vh", "70vh"]}
      >
        <MediaElement>
          {isPlaying ? (
            <video
              ref={videoRef}
              autoPlay
              loop
              muted
              playsInline
              data-wf-ignore="true"
              data-object-fit="cover"
              src={videoSrc}
            >
              <source src={videoSrc} data-wf-ignore="true" />
            </video>
          ) : heroImageBackground ? (
            <img
              src={heroImageBackground}
              alt="Hero background"
              data-object-fit="cover"
            />
          ) : null}
        </MediaElement>
      </VideoBackgroundContainer>
      {videoSrc && (
        <PlayPauseButton isPlaying={isPlaying} onClick={togglePlay} />
      )}
    </>
  );
};

export { VideoBackground };
